// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestUpdateBody = {
  poolId: string;
  contestId: string;
  roundGrouping?: "day" | "week" | null;
  weekStartDay?: number | null;
  roundLockTiming?: "firstGame" | "lastGame" | null;
  pickBasis?: "moneyline" | "spread" | null;
  spreadTiming?: "lockedEarly" | "live" | null;
  advanceCriterion?: "winAll" | "winHalfOrMore" | null;
  livesAllowed?: number | null;
  requiredPicksPerRound?: number | null;
  maxEntriesPerMember?: number | null;
  teamReuseAllowed?: boolean | null;
  teamReuseLockoutDays?: number | null;
  teamReuseMaxCount?: number | null;
  revivesAllowed?: "unlimited" | "limited" | null;
  revivesAllowedCount?: number | null;
  postponementPolicy?: "makeUpNextRound" | "countAsLoss" | null;
  tiePolicy?: "tieIsWin" | "tieIsLoss" | null;
  tiebreaker?: "splitMedal" | "noWinner" | "commissionerPick" | null;
  winPoints?: number | null;
  lossPoints?: number | null;
  skipsAllowed?: boolean | null;
  skipsMaxPerContest?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  isInitialSetup?: boolean | null;
  endDateMode?: "date" | "tbd" | null;
  pickSchedule?: {
    version: 1;
    requirements: {
      requirementId: string;
      startsOn: string;
      endsOn: string | null;
      timeZone: string;
      cadence: "day" | "week";
      weekStartDay: number | null;
      requiredPicks: number;
      revivedRequiredPicks: number | null;
      lockTiming: "firstGame" | "lastGame";
      teamReuseAllowed: boolean;
      inheritPreviousReuse: boolean;
      extendPreviousGames: boolean;
      postponementPolicy: "makeUpNextRound" | "countAsLoss";
    }[];
  } | null;
  spreadPolicy?: "automatic72h" | null;
};

export type typeContestUpdateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contestId: string;
    effectiveFromRoundId?: string | null;
    effectiveFromRoundNumber?: number | null;
  };
};

export type typeContestUpdateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestUpdateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestUpdateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestUpdateBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
    roundGrouping: {
      oneOf: [{ type: "string", enum: ["day", "week"] }, { enum: [null] }],
    },
    weekStartDay: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    roundLockTiming: {
      oneOf: [
        { type: "string", enum: ["firstGame", "lastGame"] },
        { enum: [null] },
      ],
    },
    pickBasis: {
      oneOf: [
        { type: "string", enum: ["moneyline", "spread"] },
        { enum: [null] },
      ],
    },
    spreadTiming: {
      oneOf: [
        { type: "string", enum: ["lockedEarly", "live"] },
        { enum: [null] },
      ],
    },
    advanceCriterion: {
      oneOf: [
        { type: "string", enum: ["winAll", "winHalfOrMore"] },
        { enum: [null] },
      ],
    },
    livesAllowed: {
      oneOf: [{ type: "integer" }, { enum: [null] }],
      deprecated: true,
      description:
        "Retired authoring field accepted for compatibility and ignored. New Survivor rules use one life and no skips.",
    },
    requiredPicksPerRound: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    maxEntriesPerMember: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    teamReuseAllowed: { oneOf: [{ type: "boolean" }, { enum: [null] }] },
    teamReuseLockoutDays: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    teamReuseMaxCount: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    revivesAllowed: {
      oneOf: [
        { type: "string", enum: ["unlimited", "limited"] },
        { enum: [null] },
      ],
    },
    revivesAllowedCount: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    postponementPolicy: {
      oneOf: [
        { type: "string", enum: ["makeUpNextRound", "countAsLoss"] },
        { enum: [null] },
      ],
    },
    tiePolicy: {
      oneOf: [
        { type: "string", enum: ["tieIsWin", "tieIsLoss"] },
        { enum: [null] },
      ],
    },
    tiebreaker: {
      oneOf: [
        {
          type: "string",
          enum: ["splitMedal", "noWinner", "commissionerPick"],
        },
        { enum: [null] },
      ],
    },
    winPoints: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    lossPoints: { oneOf: [{ type: "integer" }, { enum: [null] }] },
    skipsAllowed: {
      oneOf: [{ type: "boolean" }, { enum: [null] }],
      deprecated: true,
      description:
        "Retired authoring field accepted for compatibility and ignored. New Survivor rules use one life and no skips.",
    },
    skipsMaxPerContest: {
      oneOf: [{ type: "integer" }, { enum: [null] }],
      deprecated: true,
      description:
        "Retired authoring field accepted for compatibility and ignored. New Survivor rules use one life and no skips.",
    },
    startDate: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    endDate: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    isInitialSetup: { oneOf: [{ type: "boolean" }, { enum: [null] }] },
    endDateMode: {
      oneOf: [{ type: "string", enum: ["date", "tbd"] }, { enum: [null] }],
    },
    pickSchedule: {
      oneOf: [
        {
          type: "object",
          properties: {
            version: { type: "integer", enum: [1] },
            requirements: {
              type: "array",
              items: {
                type: "object",
                properties: {
                  requirementId: { type: "string" },
                  startsOn: { type: "string" },
                  endsOn: { oneOf: [{ type: "string" }, { enum: [null] }] },
                  timeZone: { type: "string" },
                  cadence: { type: "string", enum: ["day", "week"] },
                  weekStartDay: {
                    oneOf: [{ type: "integer" }, { enum: [null] }],
                  },
                  requiredPicks: { type: "integer" },
                  revivedRequiredPicks: {
                    oneOf: [{ type: "integer" }, { enum: [null] }],
                  },
                  lockTiming: {
                    type: "string",
                    enum: ["firstGame", "lastGame"],
                  },
                  teamReuseAllowed: { type: "boolean" },
                  inheritPreviousReuse: { type: "boolean" },
                  extendPreviousGames: { type: "boolean" },
                  postponementPolicy: {
                    type: "string",
                    enum: ["makeUpNextRound", "countAsLoss"],
                  },
                },
                required: [
                  "requirementId",
                  "startsOn",
                  "endsOn",
                  "timeZone",
                  "cadence",
                  "weekStartDay",
                  "requiredPicks",
                  "revivedRequiredPicks",
                  "lockTiming",
                  "teamReuseAllowed",
                  "inheritPreviousReuse",
                  "extendPreviousGames",
                  "postponementPolicy",
                ],
              },
            },
          },
          required: ["version", "requirements"],
        },
        { enum: [null] },
      ],
    },
    spreadPolicy: {
      oneOf: [{ enum: ["automatic72h"] }, { enum: [null] }],
      description:
        "Automatic shared Survivor game spread policy; absent on historical configurations.",
    },
  },
  required: ["poolId", "contestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestUpdate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestUpdateBody);
  }

  return async function postContestUpdate(
    payload: typeContestUpdateBody,
  ): Promise<typeContestUpdateOutput200 | typeContestUpdateOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestUpdate" failed before calling the network. #e4bac07268eb`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#e4bac07268eb" },
        },
        data: null,
      } as typeContestUpdateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/update`,
      httpMethod: "POST",
      options,
    })) as typeContestUpdateOutput200 | typeContestUpdateOutput400;
  };
}
